import { compose, path } from "ramda";
import { createSelector } from "reselect";
import { sortWith, ascend, prop } from "ramda";
import {
  getFiltersSection,
  getCategoriesFiltersSection,
  getAllFiltersSection
} from "./utils";
import had_internship from "components/assets/had_internship.svg";
import target from "components/assets/target.svg";
export const scopeSelector = state => state.modules.insiders;

export const getInsidersApi = compose(
  path(["api", "getInsiders"]),
  scopeSelector
);
export const getFiltersApi = compose(
  path(["api", "getFilters"]),
  scopeSelector
);
export const getInsiderApi = compose(
  path(["api", "getInsider"]),
  scopeSelector
);

export const fetchInsider = createSelector([getInsiderApi], api => api.data);

export const fetchInsiders = createSelector(
  [getInsidersApi],
  api =>
    api.data && {
      ...api.data,
      results: api.data.results.map(insider => ({
        ...insider,
        tags: [
          insider.tags.had_internship
            ? {
                label: "Had Internship",
                icon: had_internship
              }
            : { label: "", icon: "" },
          insider.tags.target_school
            ? {
                label: "Target",
                icon: target
              }
            : {
                label: "Non-Target",
                icon: target
              },
          insider.tags.mba_graduate
            ? {
                label: "MBA",
                icon: target
              }
            : {
                label: "",
                icon: ""
              },
          insider.tags.major_studied
        ]
      }))
    }
);
export const getSuggestedInsidersApi = compose(
  path(["api", "getSuggestedInsiders"]),
  scopeSelector
);

export const getAvailableTimeApi = compose(
  path(["api", "getAvailableTime"]),
  scopeSelector
);

export const askSuggestionApi = compose(
  path(["api", "askSuggestion"]),
  scopeSelector
);

export const getPositionsApi = compose(
  path(["api", "getPositions"]),
  scopeSelector
);

export const addPositionsApi = compose(
  path(["api", "addPositions"]),
  scopeSelector
);

export const getAvailabilitiesApi = compose(
  path(["api", "getAvailabilities"]),
  scopeSelector
);

export const addAvailabilityApi = compose(
  path(["api", "addAvailability"]),
  scopeSelector
);

// TODO: move to page selectors
export const getInsiderById = createSelector(
  [getInsidersApi, (_, { match }) => match.params.id],
  (api, id) =>
    api.data && api.data.find(insider => insider.id === parseInt(id, 10))
);

export const getFilters = createSelector(
  [getFiltersApi],
  api =>
    api.data && [
      {
        title: "Select Company",
        value: "company",
        label: "select a company",
        all_items_label: "Explore all companies",
        field: "company",
        items: sortWith(
          [ascend(prop("value"))],
          getCategoriesFiltersSection("companies", api.data)
        )
      },
      {
        title: "Graduated from",
        field: "graduated_from",
        value: "graduated_from",
        label: "Graduated from",
        items: [
          { value: "Target School", label: "Target School" },
          { value: "Non Target School", label: "Non Target School" },
          { value: "MBA", label: "MBA" }
        ]
      },
      {
        title: "Major studied",
        field: "major",
        value: "major",
        label: "Major Studied",
        items: getFiltersSection("majors", api.data)
      },
      {
        title: "Select Group",
        field: "group_tag",
        all_items_label: "explore all groups",
        value: "group_tag",
        label: "select a group",
        items: getCategoriesFiltersSection("group_tags", api.data)
      }
    ]
);

export const getPagination = createSelector(
  [getInsidersApi],
  api =>
    api.data && {
      count: Math.ceil(api.data.count / 10),
      next: api.data.next,
      previous: api.data.previous,
      page: api.data.page
    }
);

export const getAllInsidersReviewsApi = compose(
  path(["api", "getAllInsidersReviews"]),
  scopeSelector
);

export const getAverageInsiderRatingApi = compose(
  path(["api", "getAverageInsiderRating"]),
  scopeSelector
);

export const getCountriesApi = compose(
  path(["api", "getCountries"]),
  scopeSelector
);

export const getCallObjectivesApi = compose(
  path(["api", "getCallObjectives"]),
  scopeSelector
);

export const getCallObjectiveApi = compose(
  path(["api", "getCallObjective"]),
  scopeSelector
);

export const getCitiesApi = compose(path(["api", "getCities"]), scopeSelector);



// WEBPACK FOOTER //
// ./src/modules/insiders/selectors.js